module.exports = __webpack_public_path__ + "img/pic_2.44a80d15.png";